import { CertificateInfoResponse } from '../../models/certificate-info-response'
import { CertificateInfo, CertificateStatusEnum } from '../../models/certificate-info'
import { dateFormatWithTimeOptions } from '../../../../../../config/dateFormatterConfig'

function formatDate(date: Date | undefined): string {
  return date ? new Intl.DateTimeFormat('et', dateFormatWithTimeOptions).format(new Date(date)) : ''
}

function getStatus(certificateInfo: CertificateInfoResponse): CertificateStatusEnum {
  if (!certificateInfo.notAfter || !certificateInfo.notBefore) {
    return CertificateStatusEnum.INVALID
  }

  const now = new Date()
  const notBefore = new Date(certificateInfo.notBefore)
  const notAfter = new Date(certificateInfo.notAfter)

  if (now < notBefore) {
    return CertificateStatusEnum.NOT_ACTIVE
  }

  const oneMonthInTheFuture = new Date()
  oneMonthInTheFuture.setMonth(oneMonthInTheFuture.getMonth() + 1)

  if (notBefore <= now && now < notAfter) {
    if (notAfter < oneMonthInTheFuture) {
      return CertificateStatusEnum.DUE_TO_EXPIRE
    }

    return CertificateStatusEnum.VALID
  }

  return CertificateStatusEnum.EXPIRED
}

export function parseCertificateInfoResponse(response: CertificateInfoResponse): CertificateInfo {
  return {
    id: response.id ?? '',
    status: getStatus(response),
    name: response.name ?? '',
    subject: response.subject ?? '',
    issuer: response.issuer ?? '',
    validFrom: formatDate(response.notBefore),
    validTo: formatDate(response.notAfter),
    fingerprint: response.fingerprint ?? '',
  }
}

export function parseCertificateInfoResponses(responses: CertificateInfoResponse[]): CertificateInfo[] {
  return responses.map((response) => parseCertificateInfoResponse(response))
}
